import React, { useRef } from 'react';
var VeltCommentsSidebarV2FocusedThreadBackButton = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-focused-thread-back-button-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2FocusedThreadBackButton;
